// LOP - Product card mini-carousel
// Desktop: segunda imagen al hover (sin flechas). Mobile: scroll + flechas.
(function () {
  'use strict';

  var CAROUSEL_SEL = '.product-item__media--lop-carousel';
  var HIDDEN_CLASS = 'product-item__gallery-image--hidden';
  var MOBILE_MQ = '(max-width: 749px)';
  /** Product cards inside these sections: no inner horizontal scroll on mobile (see custom.css). */
  var NESTED_COLLECTION_SLIDER = '.featured-collection-slider, .featured-collection-slider-edit';

  // ── Helpers ────────────────────────────────────────────────────────────────

  function isMobile() {
    return window.matchMedia && window.matchMedia(MOBILE_MQ).matches;
  }

  function isNestedInCollectionSlider(media) {
    return !!(media && media.closest && media.closest(NESTED_COLLECTION_SLIDER));
  }

  function variantInList(variantId, attr) {
    if (!variantId) return false;
    var ids = (attr || '').trim();
    if (!ids) return false;
    return (',' + ids + ',').indexOf(',' + String(variantId) + ',') !== -1;
  }

  function getImages(media) {
    return media.querySelectorAll('.product-item__image--gallery');
  }

  function getSegments(media) {
    return media.querySelectorAll('.product-item__gallery-bar-segment');
  }

  function getCard(media) {
    return media.closest('.product-item');
  }

  function getVisibleImages(media) {
    var all = getImages(media);
    var out = [];
    for (var i = 0; i < all.length; i++) {
      if (!all[i].classList.contains(HIDDEN_CLASS)) out.push(all[i]);
    }
    return out;
  }

  function getVisibleSegments(media) {
    var allImg = getImages(media);
    var allSeg = getSegments(media);
    var out = [];
    for (var i = 0; i < allSeg.length; i++) {
      if (!allImg[i] || !allImg[i].classList.contains(HIDDEN_CLASS)) out.push(allSeg[i]);
    }
    return out;
  }

  function activateVisibleSlide(media, visibleIdx) {
    var vis = getVisibleImages(media);
    var segVis = getVisibleSegments(media);
    if (!vis.length || visibleIdx < 0 || visibleIdx >= vis.length) return;

    var images = getImages(media);
    var segments = getSegments(media);
    images.forEach(function (img) { img.classList.remove('active'); });
    segments.forEach(function (seg) {
      seg.classList.remove('active');
      seg.removeAttribute('aria-current');
    });

    vis[visibleIdx].classList.add('active');
    if (segVis[visibleIdx]) {
      segVis[visibleIdx].classList.add('active');
      segVis[visibleIdx].setAttribute('aria-current', 'true');
    }
  }

  // ── Variant filtering ──────────────────────────────────────────────────────

  function applyVariantFilter(media, variantId) {
    var images = getImages(media);
    var segments = getSegments(media);

    var hasVariantData = false;
    for (var i = 0; i < images.length; i++) {
      if ((images[i].getAttribute('data-variant-ids') || '').trim() !== '') {
        hasVariantData = true;
        break;
      }
    }

    var visibleImages = [];
    var visibleSegments = [];

    for (var i = 0; i < images.length; i++) {
      var variantIds = (images[i].getAttribute('data-variant-ids') || '').trim();
      var belongs = !hasVariantData || variantIds === '' || variantInList(variantId, variantIds);
      if (belongs) {
        images[i].classList.remove(HIDDEN_CLASS);
        visibleImages.push(images[i]);
        if (segments[i]) {
          segments[i].classList.remove(HIDDEN_CLASS);
          visibleSegments.push(segments[i]);
        }
      } else {
        images[i].classList.add(HIDDEN_CLASS);
        images[i].classList.remove('active');
        if (segments[i]) {
          segments[i].classList.add(HIDDEN_CLASS);
          segments[i].classList.remove('active');
          segments[i].removeAttribute('aria-current');
        }
      }
    }

    // Reset active
    images.forEach(function (img) { img.classList.remove('active'); });
    segments.forEach(function (seg) { seg.classList.remove('active'); seg.removeAttribute('aria-current'); });

    if (visibleImages.length > 0) {
      visibleImages[0].classList.add('active');
      if (visibleSegments[0]) {
        visibleSegments[0].classList.add('active');
        visibleSegments[0].setAttribute('aria-current', 'true');
      }
    }

    // Mobile: reset scroll to start (only when inner track is scrollable — not in collection sliders)
    if (isMobile() && !isNestedInCollectionSlider(media)) {
      var wrap = media.querySelector('.product-item__gallery-images-wrap');
      if (wrap) wrap.scrollLeft = 0;
    }
  }

  // Desktop: segment clicks and arrow navigation
  function desktopJumpTo(media, galleryIndex) {
    var images = getImages(media);
    var seen = 0;
    var found = -1;
    for (var i = 0; i < images.length; i++) {
      if (images[i].classList.contains(HIDDEN_CLASS)) continue;
      if (parseInt(images[i].getAttribute('data-gallery-index') || '0', 10) === galleryIndex) {
        found = seen;
        break;
      }
      seen++;
    }
    if (found < 0) return;
    activateVisibleSlide(media, found);
  }

  function desktopNavigate(media, direction) {
    var visibleImages = getVisibleImages(media);
    var total = visibleImages.length;
    if (total <= 1) return;

    var current = 0;
    for (var j = 0; j < total; j++) {
      if (visibleImages[j].classList.contains('active')) { current = j; break; }
    }
    var next = direction === 'prev'
      ? (current - 1 + total) % total
      : (current + 1) % total;
    activateVisibleSlide(media, next);
  }

  // ── Mobile navigation (native scroll) ─────────────────────────────────────

  function mobileScrollTo(media, visibleIdx) {
    var wrap = media.querySelector('.product-item__gallery-images-wrap');
    var visibleImages = getVisibleImages(media);
    if (!wrap || visibleIdx < 0 || visibleIdx >= visibleImages.length) return;
    wrap.scrollTo({ left: visibleImages[visibleIdx].offsetLeft, behavior: 'smooth' });
  }

  function mobileNavigate(media, direction) {
    var visibleImages = getVisibleImages(media);
    var total = visibleImages.length;
    if (total <= 1) return;

    if (isNestedInCollectionSlider(media)) {
      var current = 0;
      for (var j = 0; j < total; j++) {
        if (visibleImages[j].classList.contains('active')) { current = j; break; }
      }
      var next = direction === 'prev'
        ? (current - 1 + total) % total
        : (current + 1) % total;
      activateVisibleSlide(media, next);
      return;
    }

    var wrap = media.querySelector('.product-item__gallery-images-wrap');
    if (!wrap) return;
    var width = wrap.offsetWidth || wrap.clientWidth || 1;
    var cur = Math.min(Math.round(wrap.scrollLeft / width), total - 1);
    var nextIdx = direction === 'prev'
      ? Math.max(0, cur - 1)
      : Math.min(total - 1, cur + 1);
    mobileScrollTo(media, nextIdx);
  }

  function mobileJumpTo(media, galleryIndex) {
    if (isNestedInCollectionSlider(media)) {
      desktopJumpTo(media, galleryIndex);
      return;
    }
    var visibleImages = getVisibleImages(media);
    for (var i = 0; i < visibleImages.length; i++) {
      if (parseInt(visibleImages[i].getAttribute('data-gallery-index') || '0', 10) === galleryIndex) {
        mobileScrollTo(media, i);
        return;
      }
    }
  }

  // Actualizar dots según posición de scroll
  function updateDotsFromScroll(media) {
    var wrap = media.querySelector('.product-item__gallery-images-wrap');
    if (!wrap) return;
    var visibleImages = getVisibleImages(media);
    var total = visibleImages.length;
    if (!total) return;

    var width = wrap.offsetWidth || wrap.clientWidth || 1;
    var idx = Math.min(Math.round(wrap.scrollLeft / width), total - 1);

    activateVisibleSlide(media, idx);
  }

  // ── Swatch click handler ───────────────────────────────────────────────────

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = parseInt(cents, 10);
    if (isNaN(cents)) return '';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    var amount = (cents / 100).toFixed(2);
    var el = document.querySelector('.product-item__price .sale, .product-item__price span:not(.visually-hidden)');
    if (el) {
      var m = el.textContent.trim().match(/^([^\d]+)/);
      if (m) return m[1] + amount;
    }
    return '$ ' + amount;
  }

  function updateMemorialDaySaleBadge(card, swatch) {
    if (window.LOPMemorialDaySale && typeof window.LOPMemorialDaySale.sync === 'function') {
      window.LOPMemorialDaySale.sync(card, swatch);
    }
  }

  function syncMemorialDaySaleBadgeOnInit(card) {
    updateMemorialDaySaleBadge(card);
  }

  function updatePriceAndLinks(card, swatch) {
    var variantId = swatch.getAttribute('data-variant-id');
    var variantPrice = swatch.getAttribute('data-variant-price');
    var variantCompareAtPrice = swatch.getAttribute('data-variant-compare-at-price');

    if (variantId) {
      var imageLink = card.querySelector('.product-item__image-link');
      var titleLink = card.querySelector('.product-item__product-title a');
      [imageLink, titleLink].forEach(function (link) {
        if (!link) return;
        var base = (link.getAttribute('href') || '').split('?')[0];
        link.setAttribute('href', base + '?variant=' + variantId);
      });
    }

    if (variantPrice) {
      var priceContainer = card.querySelector('.product-item__price');
      if (priceContainer) {
        if (!card.dataset.originalPriceHtml) card.dataset.originalPriceHtml = priceContainer.innerHTML;
        var fp = formatMoney(variantPrice);
        var fc = variantCompareAtPrice ? formatMoney(variantCompareAtPrice) : null;
        var discountPct = 0;
        if (fc) {
          discountPct = Math.round((parseInt(variantCompareAtPrice, 10) - parseInt(variantPrice, 10)) * 100 / parseInt(variantCompareAtPrice, 10));
        }
        var html = fc
          ? '<span class="visually-hidden">Precio regular</span><s class="t-subdued">' + fc + '</s> <span class="sale">' + fp + '</span>'
          : '<span>' + fp + '</span>';
        if (fc && discountPct > 0 && card.dataset.lopShowInlineBadge === 'true') {
          var hasMinus = card.dataset.lopInlineBadgeMinus === 'true';
          html += ' <span class="product-discount-percent-badge product-discount-percent-badge--inline">' + (hasMinus ? '-' : '') + discountPct + '%</span>';
        }
        priceContainer.innerHTML = html;
        if (card.dataset) {
          card.dataset.lopListingPriceCents = String(variantPrice);
          if (variantCompareAtPrice) {
            card.dataset.lopListingCompareAtCents = String(variantCompareAtPrice);
          } else {
            delete card.dataset.lopListingCompareAtCents;
          }
        }
        if (typeof window.LOP_DEBUG_PRODUCT_CARD_PRICE !== 'undefined' && window.LOP_DEBUG_PRODUCT_CARD_PRICE) {
          console.log('[LOP carousel swatch price]', { variantId: variantId, priceCents: variantPrice, compareAtCents: variantCompareAtPrice || null });
        }

        var imgBadge = card.querySelector('.product-badge--discount-percent');
        if (imgBadge) {
          if (discountPct > 0) {
            imgBadge.textContent = (imgBadge.dataset.lopHasMinus === 'true' ? '-' : '') + discountPct + '%';
            imgBadge.style.display = '';
          } else {
            imgBadge.style.display = 'none';
          }
        }
      }
    }
  }

  function handleCarouselSwatchClick(swatch, card) {
    var variantId = swatch.getAttribute('data-variant-id');
    var variantImageUrl = swatch.getAttribute('data-variant-image-url');
    if (!variantImageUrl || !variantImageUrl.trim()) return;

    var allSwatches = card.querySelectorAll('.product-swatches-options__item--swatch');
    allSwatches.forEach(function (s) { s.classList.remove('LOP-swatch-active'); });
    swatch.classList.add('LOP-swatch-active');

    if (variantId) card.setAttribute('data-current-variant-id', variantId);

    var media = card.querySelector(CAROUSEL_SEL);
    if (media) applyVariantFilter(media, variantId || card.getAttribute('data-current-variant-id'));

    updatePriceAndLinks(card, swatch);
    updateMemorialDaySaleBadge(card, swatch);
  }

  // ── Init ───────────────────────────────────────────────────────────────────

  function setupScrollListener(media) {
    if (isNestedInCollectionSlider(media)) return;
    var wrap = media.querySelector('.product-item__gallery-images-wrap');
    if (!wrap || wrap.dataset.lopScrollBound) return;
    wrap.dataset.lopScrollBound = '1';
    var timer;
    wrap.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (isMobile()) updateDotsFromScroll(media);
      }, 40);
    }, { passive: true });
  }

  function initCard(media) {
    if (media.dataset.lopCarouselInit) return;
    media.dataset.lopCarouselInit = '1';
    var card = getCard(media);
    var variantId = card ? card.getAttribute('data-current-variant-id') : null;
    applyVariantFilter(media, variantId);
    setupScrollListener(media);
    if (card) syncMemorialDaySaleBadgeOnInit(card);
  }

  // Desktop: delegated mouseenter/leave so duplicated/cloned cards (Swiper loops,
  // section reloads, etc.) get the hover behavior without per-node re-binding.
  //
  // pendingHoverResets: WeakMap<media, rAF id> — defers mouseout resets by one
  // animation frame so phantom DOM-mutation events (relatedTarget=null) that arrive
  // immediately after a swatch-triggered innerHTML replacement are cancelled before
  // they can flicker the slide back to 0.
  var pendingHoverResets = typeof WeakMap !== 'undefined' ? new WeakMap() : null;

  function cancelPendingReset(media) {
    if (!pendingHoverResets) return;
    var id = pendingHoverResets.get(media);
    if (id) { cancelAnimationFrame(id); pendingHoverResets.delete(media); }
  }

  document.addEventListener('mouseover', function (e) {
    if (isMobile()) return;
    if (!e.target || !e.target.closest) return;
    var media = e.target.closest(CAROUSEL_SEL);
    if (!media) return;
    // Only fire when entering the media itself, not when moving between children
    if (e.relatedTarget && media.contains(e.relatedTarget)) return;
    cancelPendingReset(media); // cancel any deferred slide-0 reset
    var vis = getVisibleImages(media);
    if (vis.length >= 2) activateVisibleSlide(media, 1);
  }, true);

  document.addEventListener('mouseout', function (e) {
    if (isMobile()) return;
    if (!e.target || !e.target.closest) return;
    var media = e.target.closest(CAROUSEL_SEL);
    if (!media) return;
    // Skip when moving between children of the same media
    if (e.relatedTarget && media.contains(e.relatedTarget)) return;
    // Defer the reset by one rAF so that a mouseover arriving in the same frame
    // (phantom DOM-mutation event) can cancel it before the slide resets.
    cancelPendingReset(media);
    if (pendingHoverResets) {
      var id = requestAnimationFrame(function () {
        pendingHoverResets.delete(media);
        var vis = getVisibleImages(media);
        if (vis.length >= 1) activateVisibleSlide(media, 0);
      });
      pendingHoverResets.set(media, id);
    } else {
      var vis = getVisibleImages(media);
      if (vis.length >= 1) activateVisibleSlide(media, 0);
    }
  }, true);

  function initAll() {
    document.querySelectorAll(CAROUSEL_SEL).forEach(initCard);
  }

  // ── Click delegation ───────────────────────────────────────────────────────

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    // Flechas
    var btn = e.target.closest('.product-item__gallery-prev, .product-item__gallery-next');
    if (btn) {
      var media = btn.closest(CAROUSEL_SEL);
      if (!media) return;
      e.preventDefault();
      e.stopPropagation();
      var dir = btn.classList.contains('product-item__gallery-prev') ? 'prev' : 'next';
      if (isMobile()) mobileNavigate(media, dir);
      else desktopNavigate(media, dir);
      return;
    }

    // Dots
    var seg = e.target.closest('.product-item__gallery-bar-segment');
    if (seg) {
      var mediaBar = seg.closest(CAROUSEL_SEL);
      if (!mediaBar) return;
      e.preventDefault();
      e.stopPropagation();
      var idx = parseInt(seg.getAttribute('data-gallery-index') || '0', 10);
      if (isMobile()) mobileJumpTo(mediaBar, idx);
      else desktopJumpTo(mediaBar, idx);
      return;
    }

    // Swatch
    var sw = e.target.closest('.product-swatches-options__item--swatch');
    if (sw) {
      var card = sw.closest('.product-item');
      if (!card) return;
      var carouselMedia = card.querySelector(CAROUSEL_SEL);
      if (!carouselMedia) return;
      var url = sw.getAttribute('data-variant-image-url');
      if (!url || !url.trim()) return;
      e.preventDefault();
      e.stopPropagation();
      handleCarouselSwatchClick(sw, card);
    }
  }, true);

  // ── Boot ───────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(CAROUSEL_SEL)) { initCard(node); return; }
          if (node.querySelectorAll) node.querySelectorAll(CAROUSEL_SEL).forEach(initCard);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', initAll);

  document.addEventListener('lop:carousel-reinit', function (event) {
    var media = event.detail && event.detail.media;
    if (!media) return;

    delete media.dataset.lopCarouselInit;
    initCard(media);

    var variantId = event.detail.variantId;
    if (variantId) applyVariantFilter(media, variantId);
  });

})();
